import { NavItem } from '@/component/Navigation/types';
import { Icon } from '@/icon/Icon';
import {
  activitiesFullPath,
  alarmsFullPath,
  basicsFullPath,
  discoverDataFullPath,
  equipmentDashboardFullPath,
  equipmentDataFullPath,
  equipmentPartsFullPath,
  insightsFullPath,
  noticeBoardFullPath,
} from '../pathDefinitions';

export const fleetNavItems: NavItem[] = [
  {
    to: equipmentDashboardFullPath,
    icon: <Icon name="dashboard" size="small" />,
    label: ({ fleet }) => fleet.dashboard.header,
  },
  {
    to: equipmentDataFullPath,
    icon: <Icon name="show_chart" size="small" />,
    label: ({ fleet }) => fleet.data.header,
    access: (permissions) => permissions.includes('eqmnt.trends:r'),
  },
  {
    to: discoverDataFullPath,
    icon: <Icon name="query_stats" size="small" />,
    label: ({ fleet }) => fleet.discover.menuItem,
    access: (permissions) => permissions.includes('eqmnt.insights.highres'),
  },
  {
    to: alarmsFullPath,
    icon: <Icon name="alarms" size="small" />,
    label: ({ fleet }) => fleet.alarms.header,
  },
  {
    to: insightsFullPath,
    icon: <Icon name="insights" size="small" />,
    label: ({ fleet }) => fleet.insights.header,
    access: (permissions) => permissions.includes('insights:r'),
  },
  {
    to: noticeBoardFullPath,
    icon: <Icon name="note" size="small" />,
    label: ({ fleet }) => fleet.noticeBoard.header,
  },
  {
    to: activitiesFullPath,
    icon: <Icon name="activities" size="small" />,
    label: ({ fleet }) => fleet.activity.list.header,
    access: (permissions) => permissions.some((p) => p.startsWith('activity')),
  },
  {
    to: basicsFullPath,
    icon: <Icon name="equipment_basics" size="small" />,
    label: ({ fleet }) => fleet.basics.header,
  },
  {
    to: equipmentPartsFullPath,
    icon: <Icon name="parts" size="small" />,
    label: ({ fleet }) => fleet.partsCatalog.header,
    access: (permissions) =>
      permissions.some((p) => p.startsWith('spc.catalog:r')),
  },
];
